import { DropdownNav } from './components/dropdown_nav.js';
import { FlyoutMenu } from './components/flyout_menu.js';
import { PersonalityMenu } from './components/personality_menu.js';
import { Search } from './components/search.js';
import { Webforms } from './components/webforms.js';
/**
 * JS to run on every page using the child theme.
 */
export class RushTheme extends DrupalBehavior {
  onContent(context) {
    if (context.querySelector('.header-menu--main-menu')) {
      let mql = window.matchMedia('(min-width: 1200px)');

      var dropdownNav = new DropdownNav();
      mql.addListener(dropdownNav.init(context, mql));
      dropdownNav.init(context, mql);

      var search = new Search();

      var flyoutMenu = new FlyoutMenu();

      var personalityMenu = new PersonalityMenu();
      mql.addListener(personalityMenu.init);
      personalityMenu.init(mql);
    }

    if (context.querySelector('.webform-submission-form')) {
      var webforms = new Webforms();
    }

    function offsetAnchor() {
      if (location.hash.length !== 0) {
        window.scrollTo(window.scrollX, window.scrollY - 72);
      }
    }
    window.addEventListener('hashchange', offsetAnchor);
    window.setTimeout(offsetAnchor, 0);
  }
}

DrupalBehavior.register('rush_theme', 'global', RushTheme);
